import { render, staticRenderFns } from "./FiltersLayout.vue?vue&type=template&id=2f95b99d&lang=pug&"
import script from "./FiltersLayout.vue?vue&type=script&lang=ts&"
export * from "./FiltersLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports